import { Component, OnInit, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'dm-cart-resumo', 
  templateUrl: './dm-cart-resumo.component.html',
  styleUrls: ['./dm-cart-resumo.component.scss']
})
export class DmCartResumoComponent implements OnInit {

  @Input("servicos") servicos:any = [];
  @Input("total") total           = 0; 
  @Input("showButton") showButton = true; 
  public valorParcela:any         = 0;
  @Input("changeTotal") changeTotal = new EventEmitter();
  
  constructor() { }

  /**
   * 
   * Set valor parcela
   * 
   */
  setValorParcela(){

    this.valorParcela = (this.total/6).toFixed(2);

  }
  /**
   * 
   * On Data
   * 
   */
  onData(){

    this.changeTotal.subscribe(total => {
 
      this.total = total;
      this.setValorParcela(); 

    });

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit():void{
    this.setValorParcela();
    this.onData();
  }

}
